module.exports = __webpack_public_path__ + "static/img/prod-fashion3.5c9e7b45.jpg";